module.exports = __webpack_public_path__ + "img/PDF.04176562.png";